const Table = ({ header, body }: any) => {
  const ThComponent = ({ children }: any) => {
    return (
      <th className="whitespace-nowrap font-[900] text-sm text-black">
        {children}
      </th>
    );
  };

  const TdComponent = ({ children }: any) => {
    return <td className="whitespace-nowrap text-sm">{children}</td>;
  };

  return (
    <table className="table table-pin-rows">
      <thead>
        <tr className="cursor-pointer hover duration-300 bg-gray-100">
          {header.map((headetItem: string, idx: number) => (
            <ThComponent key={idx}>{headetItem}</ThComponent>
          ))}
        </tr>
      </thead>
      <tbody>{body}</tbody>
    </table>
  );
};

export default Table;
